import BrotherSdk from 'bpac-js';
import NotificationError from '../components/notifications/NotificationError';
import { Helper } from './helper';
export const printSKU = async (
  sku: string,
  errorString: string,
  setLoadingPrintSku?: (loadingPrintSku: boolean) => void,
) => {
  const printer = new BrotherSdk({
    templatePath: Helper.getSourceFile('ebay-return/SKUラベル_20220808_edited.lbx'),
    exportDir: 'F:/TCOM/eBayReturn/',
  });

  const data = {
    SKU: sku,
    txtSKU: sku,
  };

  // const options = {
  //   copies: 1, // Optional - Defaults: 1
  //   printName: sku, // Optional - Defaults: BPAC-Document
  //   highResolution: true // Optional
  // }
  if (setLoadingPrintSku) setLoadingPrintSku(true);
  try {
    // const isPrinted = await printer.getImageData(data, { width: 2000, height: 4000 });
    await printer.print(data, { quality: true, highResolution: true, autoCut: true });

    // console.log({ isPrinted });
  } catch (error) {
    console.log('Error from printSKU:', error);

    let message = errorString;

    if (error.response && error.response.data && error.response.data.message) {
      message = error.response.data.message;
    } else if (error.message) {
      message = error.message;
    }

    NotificationError({
      content: message,
    });
  } finally {
    // Set loading to false after printing (regardless of success or failure)
    if (setLoadingPrintSku) setLoadingPrintSku(false);
  }
};
